'use client';

export interface ServiceHeroBlurbProps {
  headingLargeText: string;
  headingSmallText: string;
}

export function ServiceHeroBlurb({ headingLargeText, headingSmallText }: ServiceHeroBlurbProps) {
  return (
    <div className="relative z-10 mt-6 flex justify-center tablet:mt-[74px] tablet:pt-0">
      <div className="flex w-full max-w-full justify-center px-4 tablet:w-full tablet:max-w-[1200px] tablet:justify-end">
        <div className="w-full bg-white p-6 tablet:w-full tablet:max-w-[640px]">
          <p className="mb-0 font-heldane text-serviceBlurbTitle font-normal leading-[1.2] text-navy">
            {headingLargeText}
          </p>
          <p className="mt-6 font-soehne text-serviceBlurbBody font-normal leading-[150%] text-navy tablet:mt-12">
            {headingSmallText}
          </p>
        </div>
      </div>
    </div>
  );
}
